// module.exports = {
//     server: process.env.NODE_ENV !== 'production' ? 'kgh5.hansdata.com' : 'https://kg.1ksf.cn/',
//     port: process.env.NODE_ENV !== 'production' ? '80' : '80',
//     api: process.env.NODE_ENV !== 'production' ? 'http://kgh5.hansdata.com/afzj' : 'https://kg.1ksf.cn/afzj',
// }


module.exports = {
   server: process.env.NODE_ENV !== 'production' ? 'kgh5.hansdata.com' : 'https://kgh5.hansdata.com/',
   // server: process.env.NODE_ENV !== 'production' ? 'h5.hansdata.com' : 'https://kgh5.hansdata.com/',
   port: process.env.NODE_ENV !== 'production' ? '80' : '80',
   // api: process.env.NODE_ENV !== 'production' ? 'http://kgh5.hansdata.com/afzj' : 'https://kgh5.hansdata.com/afzj',
   api: process.env.NODE_ENV !== 'production' ? 'https://kgh5.hansdata.com/afzj' : 'https://kgh5.hansdata.com/afzj',
}



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 156
// module chunks = 16